import { useEffect, useId, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function isNavActive(to, location, end = false) {
  const [path, search] = to.split('?');
  if (end) {
    return location.pathname === path && (!search || location.search === `?${search}`);
  }
  if (search) {
    return location.pathname === path && location.search === `?${search}`;
  }
  return location.pathname === path || (path !== '/' && location.pathname.startsWith(`${path}/`));
}

const ICONS = {
  home: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z" strokeLinejoin="round" />
    </svg>
  ),
  projects: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="4" width="7" height="7" rx="1.5" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" />
    </svg>
  ),
  clients: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="9" cy="8" r="3" />
      <path d="M4 19a5 5 0 0 1 10 0" strokeLinecap="round" />
      <circle cx="17" cy="9" r="2.2" />
      <path d="M20.5 19a4 4 0 0 0-4-3.2" strokeLinecap="round" />
    </svg>
  ),
  work: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="7" width="16" height="13" rx="2" />
      <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
    </svg>
  ),
  inbox: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 13l2.2-7.2A2 2 0 0 1 8.1 4.5h7.8a2 2 0 0 1 1.9 1.3L20 13v6a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19v-6z" />
      <path d="M4 13h4.2l1.3 2h5l1.3-2H20" strokeLinejoin="round" />
    </svg>
  ),
  time: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v4.2L15 15" strokeLinecap="round" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 4.5v2M12 17.5v2M4.5 12h2M17.5 12h2M6.4 6.4l1.4 1.4M16.2 16.2l1.4 1.4M17.6 6.4l-1.4 1.4M7.8 16.2l-1.4 1.4" strokeLinecap="round" />
    </svg>
  ),
  files: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5H11l2 2h4.5A1.5 1.5 0 0 1 19 8.5V18a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18V6.5z" />
    </svg>
  ),
  messages: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M5 18.5l-1 3 3.4-1.2A8.5 8.5 0 1 0 5 18.5z" strokeLinejoin="round" />
    </svg>
  ),
  plans: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M5 7h14v12H5z" />
      <path d="M9 7V5h6v2M9 12h6M9 16h4" strokeLinecap="round" />
    </svg>
  ),
  directory: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="5" width="16" height="14" rx="2" />
      <path d="M8 9h8M8 13h5" strokeLinecap="round" />
    </svg>
  ),
  billing: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="3.5" y="6" width="17" height="12" rx="2" />
      <path d="M3.5 10h17M8 15h4" strokeLinecap="round" />
    </svg>
  ),
  integrations: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="7" cy="7" r="2.3" />
      <circle cx="17" cy="7" r="2.3" />
      <circle cx="7" cy="17" r="2.3" />
      <circle cx="17" cy="17" r="2.3" />
      <path d="M9.3 7h5.4M7 9.3v5.4M17 9.3v5.4" />
    </svg>
  ),
  hosts: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="4" width="16" height="6" rx="1.5" />
      <rect x="4" y="14" width="16" height="6" rx="1.5" />
      <path d="M7 7h.01M7 17h.01" strokeLinecap="round" />
    </svg>
  ),
  activity: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M4 12h3l2.5-6 4 12 2.5-6H20" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <rect x="4" y="5" width="16" height="15" rx="2" />
      <path d="M8 3.5V7M16 3.5V7M4 10h16" strokeLinecap="round" />
    </svg>
  ),
  more: (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="6" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="18" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  ),
};

export function SidebarIcon({ name }) {
  return <span className="sidebar-icon">{ICONS[name] || ICONS.home}</span>;
}

export function SidebarHelp({ title = 'Need help?', body = 'Contact support if you get stuck.', actionLabel = 'Contact support', href }) {
  return (
    <div className="sidebar-help">
      <strong>{title}</strong>
      <p>{body}</p>
      {href ? (
        <a className="sidebar-help-btn" href={href}>
          {actionLabel}
        </a>
      ) : null}
    </div>
  );
}

export function SidebarLink({ to, label, end = false, tourId, icon }) {
  const location = useLocation();
  const active = isNavActive(to, location, end);

  return (
    <Link
      to={to}
      className={`sidebar-link${active ? ' is-active' : ''}`}
      data-tour={tourId || undefined}
    >
      {icon ? <SidebarIcon name={icon} /> : null}
      <span>{label}</span>
    </Link>
  );
}

export function SidebarMore({ label = 'More', paths = [], children }) {
  const location = useLocation();
  const id = useId();
  const isActive = paths.some((path) => isNavActive(path, location));
  const [open, setOpen] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setOpen(true);
    }
  }, [isActive, location.pathname]);

  return (
    <div className={`sidebar-group sidebar-more${open ? ' is-open' : ''}${isActive ? ' is-active' : ''}`}>
      <button
        type="button"
        className="sidebar-group-trigger"
        data-tour="tour-nav-more"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((value) => !value)}
      >
        <SidebarIcon name="more" />
        <span className="sidebar-group-label">{label}</span>
        <span className="sidebar-group-chevron" aria-hidden>
          ▾
        </span>
      </button>
      <div id={id} className="sidebar-more-panel" hidden={!open}>
        {children}
      </div>
    </div>
  );
}

export function SidebarGroup({ label, items, tourId, icon }) {
  const location = useLocation();
  const id = useId();
  const visible = items.filter((item) => item.show !== false);
  const isActive = visible.some((item) => isNavActive(item.to, location, item.end));
  const [open, setOpen] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setOpen(true);
    }
  }, [isActive]);

  if (!visible.length) {
    return null;
  }

  return (
    <div className={`sidebar-group${open ? ' is-open' : ''}${isActive ? ' is-active' : ''}`}>
      <button
        type="button"
        className="sidebar-group-trigger"
        data-tour={tourId || undefined}
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen((v) => !v)}
      >
        {icon ? <SidebarIcon name={icon} /> : null}
        <span className="sidebar-group-label">{label}</span>
        <span className="sidebar-group-chevron" aria-hidden>
          ▾
        </span>
      </button>
      <div id={id} className="sidebar-group-panel" hidden={!open}>
        {visible.map((item) => {
          const active = isNavActive(item.to, location, item.end);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`sidebar-sublink${active ? ' is-active' : ''}`}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
